import { PartnerOnBoardComponent } from './components/partner-on-board/partner-on-board.component';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { FormsModule , ReactiveFormsModule} from '@angular/forms';
import { HttpClientModule , HTTP_INTERCEPTORS} from '@angular/common/http';
import { HashLocationStrategy, LocationStrategy, DatePipe } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DunsIdComponent } from './components/duns-id/duns-id.component';
import { MonthlyExceptionsReportsComponent } from './components/monthly-exceptions-reports/monthly-exceptions-reports.component';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { LoginComponent } from './components/login/login.component';
import { PoTableComponent } from './components/po-table/po-table.component';
import { PoTableacrTableComponent } from './components/po-tableacr-table/po-tableacr-table.component';
import { PurchaseOrderComponent } from './components/purchase-order/purchase-order.component';
import { UserAccessComponent } from './components/user-access/user-access.component';
import { FulfillmentreportComponent } from './components/fulfillmentreport/fulfillmentreport.component';
import { PagenotfoundComponent } from './components/pagenotfound/pagenotfound.component';
import {NgxPaginationModule} from 'ngx-pagination';
import { UserAdminComponent } from './components/user-admin/user-admin.component';
import { PartnerAdminComponent } from './components/partner-admin/partner-admin.component';
import { PoReportComponent } from './components/po-report/po-report.component';
import { ServicesComponent } from './components/services/services.component';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { AccordionModule, AccordionConfig } from 'ngx-bootstrap/accordion';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { OrderDetailsComponent } from './components/order-details/order-details.component';
import { PoOrderByPipe } from './pipes/po-order-by.pipe';
import { CookieService } from 'ngx-cookie-service';
import { UserAdminCrBtnComponent } from './components/user-admin-cr-btn/user-admin-cr-btn.component';
import { MonthlyLocationReportComponent } from './components/monthly-location-report/monthly-location-report.component';
import { MonthlyExceptionsReportM2MComponent } from './components/monthly-exceptions-report-m2-m/monthly-exceptions-report-m2-m.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { GroupByPipe } from './pipes/group-by.pipe';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { MonthlyExceptionsReportCCComponent } from './components/monthly-exceptions-report-cc/monthly-exceptions-report-cc.component';
import { UnprocessedPoReportComponent } from './components/unprocessed-po-report/unprocessed-po-report.component';
import { EdiEdparComponent } from './components/edi-edpar/edi-edpar.component';
import { PBandJReportComponent } from './components/pband-jreport/pband-jreport.component';
import { BOLReportComponent } from './components/bol-report/bol-report.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import {ConfirmDialogService} from './services/confirm-dialog.service';
import { CustomerMaterialComponent } from './components/customer-material/customer-material.component';
import { BackButtonComponent } from './components/back-button/back-button.component';
import { PartnerStoreComponent } from './components/partner-store/partner-store.component';
import { TwoColumnGroupByPipe } from './pipes/two-column-group-by.pipe';
import { PurchaseOrderReportComponent } from './components/purchase-order-report/purchase-order-report.component';
import { CreateTestPoComponent } from './components/create-test-po/create-test-po.component';
import { CreateTestBolComponent } from './components/create-test-bol/create-test-bol.component';
import { ExtLogComponent } from './components/ext-log/ext-log.component';
import { ServiceStatusComponent } from './components/service-status/service-status.component';
import { UiSwitchModule } from 'ngx-toggle-switch';
import {TabsModule} from 'ngx-tabset';
import { PartnerOnboardingCreateComponent } from './components/partner-onboarding-create/partner-onboarding-create.component';
import { EnvConfigService } from './services/env-config.service';
import { PartnerOnboardingEditComponent } from './components/partner-onboarding-edit/partner-onboarding-edit.component';
import { DigitOnlyModule } from '@uiowa/digit-only';
import { LocationReportComponent } from './components/location-report/location-report.component';
import { AuthGaurdService } from './services/auth-gaurd.service';
import { PoLineItemDetailReportComponent } from './components/po-line-item-detail-report/po-line-item-detail-report.component';
import { CancelPoComponent } from './components/cancel-purchase-order/cancel-purchase-order.component';
import { CancelZcraZdra } from './components/cancel-zcra-zdra/cancel-zcra-zdra.component';

const appInitializerFn = (appConfig: EnvConfigService) => {
  return () => {
    return appConfig.loadAppConfig();
  };
};


@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    LoginComponent,
    PoTableComponent,
    PoTableacrTableComponent,    
    PurchaseOrderComponent,
    UserAccessComponent,
    FulfillmentreportComponent,
    PagenotfoundComponent,
    UserAdminComponent,
    PartnerAdminComponent,
    PoReportComponent,
    ServicesComponent,
    OrderDetailsComponent,
    PoOrderByPipe,
    UserAdminCrBtnComponent,
    MonthlyLocationReportComponent,
    MonthlyExceptionsReportM2MComponent,
    GroupByPipe,
    MonthlyExceptionsReportCCComponent,
    UnprocessedPoReportComponent,
    EdiEdparComponent,
    ConfirmDialogComponent,
    PBandJReportComponent,
    CustomerMaterialComponent,
    BackButtonComponent,
    DunsIdComponent,
    PartnerStoreComponent,
    TwoColumnGroupByPipe,
    PurchaseOrderReportComponent,
    CreateTestPoComponent,
    CreateTestBolComponent,
    ExtLogComponent,
    ServiceStatusComponent,
    PartnerOnBoardComponent,
    PartnerOnboardingCreateComponent,
    PartnerOnboardingEditComponent,
    MonthlyExceptionsReportsComponent,
    BOLReportComponent,
    LocationReportComponent,
    PoLineItemDetailReportComponent,
    CancelPoComponent,
    CancelZcraZdra
  ],
  imports: [
  BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    NgxPaginationModule,
    NgxDaterangepickerMd.forRoot(),
     AccordionModule.forRoot(),
     ModalModule.forRoot(),
     BsDatepickerModule.forRoot(),
    BrowserAnimationsModule,
    UiSwitchModule,
    TabsModule.forRoot(),
    DigitOnlyModule
  ],
  providers: [{provide: LocationStrategy, useClass: HashLocationStrategy},
    // {
    //   provide: APP_INITIALIZER,
    //   useFactory: appInitializerFn,
    //   multi: true,
    //   deps: [EnvConfigService]
    //   },

    { provide: AuthGaurdService, useClass: AuthGaurdService },
    PoOrderByPipe, DatePipe, CookieService, GroupByPipe, ConfirmDialogService, TwoColumnGroupByPipe ],
  bootstrap: [AppComponent]
})
export class AppModule { }
